// extracted by mini-css-extract-plugin
export default {"wrapper":"TabWrapper_wrapper__2szCO","header":"TabWrapper_header__ldtw7"};